/**
 * 判断浏览器是否支持flex
 */
export const checkBrowserRunnable = () => {
	const elem = document.createElement('div');
	if (!('flexWrap' in elem.style)) {
		alert('您的浏览器版本过低，请升级浏览器版本');
		location.href = 'http://wap.uc.cn';
	}
};
/**
 * 判断是否是微信浏览器
 */
export const isWxBrowser = () => {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
};

export const isMobile = () => {
	return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
		window.navigator.userAgent
	);
};

export const isIE = () => {
	return !!window.ActiveXObject || 'ActiveXObject' in window;
};
